  import React, { useState, useEffect } from "react";
  import axios from "axios";
  import colors from "../Constant/colors";

  const ConcessionHeadPage = () => {
    const sessionId = localStorage.getItem("currentSessionId");
  const [concessionMode, setConcessionMode] = useState(""); 
const [admissionConcessions, setAdmissionConcessions] = useState([]);


    // ---------- STATE ----------
    const [form, setForm] = useState({
      headName: "",
      discount: "",
      discountAmount: "",
      discountType: "percentage",
      applyOn: "",
      feeHeadId: "",
      classId: "",
      sectionId: "",
      studentType: "",
    });

    const [concessionHeads, setConcessionHeads] = useState([]);
    const [feeHeads, setFeeHeads] = useState([]);
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    // ---------- INPUT HANDLER ----------
    const updateForm = (key, value) => {
      setForm((prev) => ({ ...prev, [key]: value }));
    };

    // ---------- FETCH ----------
    useEffect(() => {
      if (!sessionId) {
        showMessage("error", "Session not selected");
        return;
      }
      fetchConcessions();
      fetchFeeHeads();
      fetchClasses();
    }, [sessionId]);
const fetchAdmissionConcessions = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/admissionConcession`,
      { params: { sessionId } }
    );
    setAdmissionConcessions(res.data || []);
  } catch (err) {
    showMessage("error", "Failed to load admission concessions");
  }
};
useEffect(() => {
  if (!sessionId) return;

  if (concessionMode === "master") {
    fetchAdmissionConcessions();
  }

  if (concessionMode === "ongoing") {
    fetchConcessions();
  }
}, [concessionMode, sessionId]);

    const fetchConcessions = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/concession/getconcession`, {
          params: { sessionId },
        });
        setConcessionHeads(res.data || []);
      } catch (err) {
        showMessage("error", "Failed to load concessions");
      }
    };

    const fetchFeeHeads = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/feeheads/getFeeHeads`, {
          params: { sessionId },
        });
        setFeeHeads(res.data || []);
      } catch (err) {
        showMessage("error", "Failed to load fee heads");
        setFeeHeads([]);
      }
    };

    const fetchClasses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`, {
          params: { sessionId },
        });
        setClasses(res.data || []);
      } catch (err) {
        showMessage("error", "Failed to load classes");
        setClasses([]);
      }
    };

    // ---------- FETCH SECTIONS ----------
    useEffect(() => {
      if (!form.classId) {
        setSections([]);
        updateForm("sectionId", "");
        return;
      }

      const selectedClass = classes.find((c) => c._id === form.classId)?.className;
      if (!selectedClass) return;

      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/sections/${encodeURIComponent(selectedClass)}/getSectionsByClassName`, {
          params: { sessionId },
        })
        .then((res) => {
          const data = Array.isArray(res.data) ? res.data : res.data.sections || [];
          setSections(data);
          updateForm("sectionId", "");
        })
        .catch(() => {
          setSections([]);
        });
    }, [form.classId, classes, sessionId]);

    // ---------- MESSAGE HELPER ----------
    const showMessage = (type, text) => {
      setMessage({ type, text });
      setTimeout(() => setMessage({ type: "", text: "" }), 2500);
    };

    // ---------- VALIDATION ----------
  const validate = () => {
    // ✅ ADMISSION CONCESSION
    if (concessionMode === "master") {
      if (!form.headName.trim()) return "Concession name is required";

      if (form.discountType === "percentage") {
        const num = Number(form.discount);
        if (isNaN(num) || num < 0 || num > 100)
          return "Percentage must be 0-100";
      }

      if (form.discountType === "amount") {
        const num = Number(form.discountAmount);
        if (isNaN(num) || num < 0)
          return "Amount must be valid";
      }

      return null;
    }

    // ✅ ON-GOING CONCESSION (existing logic)
    if (!form.headName.trim()) return "Concession name is required";
    if (!form.studentType) return "Please select student type";
    if (!form.applyOn) return "Select Apply On";
    if (form.applyOn === "head" && !form.feeHeadId)
      return "Please select a fee head";

    if (form.discountType === "percentage") {
      const num = Number(form.discount);
      if (isNaN(num) || num < 0 || num > 100)
        return "Percentage must be 0-100";
    }

    if (form.discountType === "amount") {
      const num = Number(form.discountAmount);
      if (isNaN(num) || num < 0)
        return "Amount must be a valid number";
    }

    return null;
  };

    // ---------- SUBMIT ----------
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!sessionId) return showMessage("error", "Session not selected");

  const error = validate();
  if (error) return showMessage("error", error);

  setLoading(true);

  try {
    let res;

    // ✅ ADMISSION
    if (concessionMode === "master") {
      const payload = {
        sessionId,
        headName: form.headName,
        discountType: form.discountType,
        discount:
          form.discountType === "percentage" ? Number(form.discount) : 0,
        discountAmount:
          form.discountType === "amount" ? Number(form.discountAmount) : 0,
      };

      res = editId
        ? await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/concession/UpdateadmissionConcession/${editId}`,
            payload
          )
        : await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/concession/admission-concession`,
            payload
          );

      await fetchAdmissionConcessions();
    }

    // ✅ ONGOING
    else {
      const payload = {
        sessionId,
        headName: form.headName,
        className: form.classId
          ? classes.find((c) => c._id === form.classId)?.className
          : "ALL",
        section: form.sectionId
          ? sections.find((s) => s._id === form.sectionId)?.sectionName
          : "ALL",
        studentType: form.studentType || "ALL",
        applyOn: "head",
        discountType: form.discountType,
        discount:
          form.discountType === "percentage" ? Number(form.discount) : 0,
        discountAmount:
          form.discountType === "amount" ? Number(form.discountAmount) : 0,
        feeHeadId: form.feeHeadId,
        feeHeadName:
          feeHeads.find((f) => f._id === form.feeHeadId)?.headName || null,
      };

      res = editId
        ? await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/concession/updateconcession/${editId}`,
            payload
          )
        : await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/concession/createconcession`,
            payload
          );

      fetchConcessions();
    }

    showMessage("success", "Concession saved successfully");
    resetForm();
  } catch (err) {
    showMessage("error", err?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};


const handleDeleteAdmission = async (id) => {
  if (!window.confirm("Delete admission concession?")) return;

  try {
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/deleteadmissionConcession/${id}`
    );

    setAdmissionConcessions((prev) =>
      prev.filter((c) => c._id !== id)
    );

    showMessage("success", "Admission concession deleted");
  } catch {
    showMessage("error", "Failed to delete admission concession");
  }
};
const handleEditAdmission = (item) => {
  setEditId(item._id);
  setConcessionMode("master");

  setForm({
    headName: item.headName,
    discountType: item.discountType,
    discount: item.discount,
    discountAmount: item.discountAmount,
    applyOn: "",
    feeHeadId: "",
    classId: "",
    sectionId: "",
    studentType: "",
  });
};

    // ---------- RESET ----------
    const resetForm = () => {
      setForm({
        headName: "",
        discount: "",
        discountAmount: "",
        discountType: "percentage",
        applyOn: "",
        feeHeadId: "",
        classId: "",
        sectionId: "",
        studentType: "",
      });
      setEditId(null);
    };

    // ---------- EDIT ----------
    const handleEdit = (item) => {
      const classObj = classes.find((c) => c.className === item.className);
      const sectionObj = sections.find((s) => s.sectionName === item.section);
      const feeObj = feeHeads.find((f) => f.headName === item.feeHeadName);

      setEditId(item._id);
      setForm({
        headName: item.headName,
        discount: item.discount,
        discountAmount: item.discountAmount,
        discountType: item.discountType,
        applyOn: item.applyOn,
        feeHeadId: feeObj?._id || "",
        classId: classObj?._id || "",
        sectionId: sectionObj?._id || "",
        studentType: item.studentType,
      });
    };

    // ---------- DELETE ----------
    const handleDelete = async (id) => {
      if (!window.confirm("Delete this concession?")) return;
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/concession/deleteconcession/${id}`, {
          data: { sessionId },
        });
        setConcessionHeads((prev) => prev.filter((c) => c._id !== id));
        showMessage("success", "Deleted successfully");
      } catch {
        showMessage("error", "Failed to delete");
      }
    };



    // ---------- STYLES ----------
    const inputStyle = {
      fontSize: "14px",
      border: "1px solid #1E40AF",
      padding: "10px",
      borderRadius: "8px",
      background: "#fff",
      width: "100%",
    };

    const buttonStyle = {
      background: colors.gradientPrimary,
      padding: "10px 22px",
      color: "#fff",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      fontWeight: "600",
    };

    // ---------- UI ----------
    return (
      <div className="min-h-screen bg-white flex justify-center py-6 px-4">
        <div className="w-full max-w-5xl">
          <h1 className="text-3xl font-bold text-blue-800 mb-2">Concession Heads</h1>
          <p className="text-gray-600 mb-6">Manage concession categories</p>
  <div className="mb-6">
    <label className="block mb-2 font-semibold text-gray-700">
      Select Concession Type
    </label>

    <div className="flex gap-6">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="concessionMode"
          value="master"
          checked={concessionMode === "master"}
          onChange={() => setConcessionMode("master")}
        />
        <span>Admission / Permanent Concession</span>
      </label>

      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="concessionMode"
          value="ongoing"
          checked={concessionMode === "ongoing"}
          onChange={() => setConcessionMode("ongoing")}
        />
        <span>On-going / Fee Collection Concession</span>
      </label>
    </div>
  </div>

          {/* FORM */}
          {concessionMode === "master" && (
    <div className="bg-white shadow rounded p-5 border mb-6">
      <h2 className="text-xl font-semibold mb-4">
        Admission Concession
      </h2>

      <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-3">
        <input
          type="text"
          placeholder="Concession Name"
          value={form.headName}
          onChange={(e) => updateForm("headName", e.target.value)}
          style={inputStyle}
        />

        <select
          value={form.discountType}
          onChange={(e) => updateForm("discountType", e.target.value)}
          style={inputStyle}
        >
          <option value="percentage">Percentage (%)</option>
          <option value="amount">Amount (₹)</option>
        </select>

        {form.discountType === "percentage" ? (
          <input
            type="number"
            placeholder="Discount (%)"
            value={form.discount}
            onChange={(e) => updateForm("discount", e.target.value)}
            style={inputStyle}
          />
        ) : (
          <input
            type="number"
            placeholder="Amount (₹)"
            value={form.discountAmount}
            onChange={(e) => updateForm("discountAmount", e.target.value)}
            style={inputStyle}
          />
        )}

        <button style={buttonStyle}>
          Add
        </button>
      </form>
    </div>
  )}

          {concessionMode === "ongoing"  && (
          <div className="bg-white shadow rounded p-5 border mb-6">
            <h2 className="text-xl font-semibold mb-4">{editId ? "Edit Concession" : "Add New Concession"}</h2>

            <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-3">
              <input
                type="text"
                placeholder="Concession Name"
                value={form.headName}
                onChange={(e) => updateForm("headName", e.target.value)}
                style={inputStyle}
              />

              <select
                value={form.classId}
                onChange={(e) => updateForm("classId", e.target.value)}
                style={inputStyle}
              >
                <option value="">All Classes</option>
                {classes.map((c) => (
                  <option key={c._id} value={c._id}>{c.className}</option>
                ))}
              </select>

              <select
                value={form.sectionId}
                onChange={(e) => updateForm("sectionId", e.target.value)}
                style={inputStyle}
                disabled={!sections.length}
              >
                <option value="">All Sections</option>
                {sections.map((s) => (
                  <option key={s._id} value={s._id}>{s.sectionName}</option>
                ))}
              </select>

              <select
                value={form.studentType}
                onChange={(e) => updateForm("studentType", e.target.value)}
                style={inputStyle}
              >
                <option value="">Select Student Type</option>
                <option value="New Student">New Student</option>
                <option value="Old Student">Old Student</option>
              </select>

              <div className="col-span-3 flex gap-6 my-2">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.discountType === "percentage"}
                    onChange={() => updateForm("discountType", "percentage")}
                  />
                  Percentage (%)
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={form.discountType === "amount"}
                    onChange={() => updateForm("discountType", "amount")}
                  />
                  Amount (₹)
                </label>
              </div>

              {form.discountType === "percentage" && (
                <input
                  type="number"
                  placeholder="Discount (%)"
                  value={form.discount}
                  onChange={(e) => updateForm("discount", e.target.value)}
                  style={inputStyle}
                />
              )}

              {form.discountType === "amount" && (
                <input
                  type="number"
                  placeholder="Amount (₹)"
                  value={form.discountAmount}
                  onChange={(e) => updateForm("discountAmount", e.target.value)}
                  style={inputStyle}
                />
              )}

              <select
    value={form.applyOn}
    onChange={(e) => updateForm("applyOn", e.target.value)}
    style={inputStyle}
  >
    <option value="">Apply On</option>
    <option value="head">Particular Head</option>
  </select>


              {form.applyOn === "head" && (
                <select
                  value={form.feeHeadId}
                  onChange={(e) => updateForm("feeHeadId", e.target.value)}
                  style={inputStyle}
                >
                  <option value="">Select Fee Head</option>
                  {feeHeads.map((fh) => (
                    <option key={fh._id} value={fh._id}>{fh.headName}</option>
                  ))}
                </select>
              )}

              <button style={buttonStyle} disabled={loading} className="mt-2">
                {loading ? (editId ? "Updating..." : "Saving...") : editId ? "Update" : "Add"}
              </button>
            </form>

            {message.text && (
              <p className={`mt-3 text-sm ${message.type === "error" ? "text-red-500" : "text-green-600"}`}>
                {message.text}
              </p>
            )}
          </div>
  )}
          {/* TABLE */}
          {concessionMode === "master" && (
    <div className="bg-white shadow rounded p-5 border">
      <h2 className="text-xl font-semibold mb-3">
        Admission Concessions
      </h2>

      {admissionConcessions.length ? (
        <table className="min-w-full border rounded">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2">#</th>
              <th className="border px-3 py-2">Name</th>
              <th className="border px-3 py-2">Discount</th>
              <th className="border px-3 py-2">Type</th>
            </tr>
          </thead>
          <tbody>
            {admissionConcessions.map((item, i) => (
<tr key={item._id}>
  <td className="border px-3 py-2">{i + 1}</td>
  <td className="border px-3 py-2">{item.headName}</td>
  <td className="border px-3 py-2">
    {item.discountType === "percentage"
      ? `${item.discount}%`
      : `₹${item.discountAmount}`}
  </td>
  <td className="border px-3 py-2 capitalize">
    {item.discountType}
  </td>
  <td className="border px-3 py-2 flex gap-2">
    <button
      onClick={() => handleEditAdmission(item)}
      className="bg-blue-500 text-white px-3 py-1 rounded"
    >
      Edit
    </button>
    <button
      onClick={() => handleDeleteAdmission(item._id)}
      className="bg-red-500 text-white px-3 py-1 rounded"
    >
      Delete
    </button>
  </td>
</tr>

            ))}
          </tbody>
        </table>
      ) : (
        <p>No admission concessions found.</p>
      )}
    </div>
  )}
  {concessionMode === "ongoing" && (
          <div className="bg-white shadow rounded p-5 border">
            <h2 className="text-xl font-semibold mb-3">Existing Concessions</h2>
            {concessionHeads.length ? (
              <div className="overflow-x-auto">
                <table className="min-w-full border rounded">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2">#</th>
                      <th className="border px-3 py-2">Name</th>
                      <th className="border px-3 py-2">Discount</th>
                      <th className="border px-3 py-2">Type</th>
                      <th className="border px-3 py-2">Apply On</th>
                      <th className="border px-3 py-2">Class</th>
                      <th className="border px-3 py-2">Section</th>
                      <th className="border px-3 py-2">Student Type</th>
                      <th className="border px-3 py-2">Fee Head</th>
                      <th className="border px-3 py-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {concessionHeads.map((item, index) => (
                      <tr key={item._id}>
                        <td className="border px-3 py-2">{index + 1}</td>
                        <td className="border px-3 py-2">{item.headName}</td>
                        <td className="border px-3 py-2">
                          {item.discountType === "percentage"
                            ? `${item.discount}%`
                            : `₹${item.discountAmount}`}
                        </td>
                        <td className="border px-3 py-2 capitalize">{item.discountType}</td>
                        <td className="border px-3 py-2">Particular Head</td>
                        <td className="border px-3 py-2">{item.className}</td>
                        <td className="border px-3 py-2">{item.section}</td>
                        <td className="border px-3 py-2">{item.studentType}</td>
                        <td className="border px-3 py-2">{item.feeHeadName || "--"}</td>
                        <td className="border px-3 py-2 flex gap-2">
                          <button onClick={() => handleEdit(item)} className="bg-blue-500 text-white px-3 py-1 rounded">Edit</button>
                          <button onClick={() => handleDelete(item._id)} className="bg-red-500 text-white px-3 py-1 rounded">Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No concessions found.</p>
            )}
          </div>
          )}

        </div>
        
      </div>
    );
  };

  export default ConcessionHeadPage;
